jQuery(function($){
  if ($('.social-share').length > 0) {
    // console.log('window.location.href', window.location.href);
    // console.log('window.isSecureContext', window.isSecureContext);

    const pageUrl = window.location.href;

    $('.share-link').on('click', function(e) {
      e.preventDefault();

      const platform = $(this).data('platform');
      const subject = $(this).data('subject');
      let url;

      if (platform === 'facebook') {
        url = 'https://www.facebook.com/sharer.php?u=' + pageUrl;
        url = encodeURI(url);

        window.open(url, 'mywin','left=20,top=20,width=500,height=500,toolbar=1,resizable=0');
      }

      if (platform === 'twitter') {
        url = 'https://twitter.com/intent/tweet?text=' + subject + ' ' + pageUrl;
        url = encodeURI(url);

        window.open(url, 'mywin','left=20,top=20,width=500,height=500,toolbar=1,resizable=0');
      }

      if (platform === 'linkedin') {
        url = 'https://www.linkedin.com/shareArticle?mini=true&url=' + pageUrl;
        url = encodeURI(url);

        window.open(url, 'mywin','left=20,top=20,width=500,height=500,toolbar=1,resizable=0');
      }

      if (platform === 'telegram') {
        url = 'https://t.me/share?url=' + pageUrl;
        url = encodeURI(url);

        window.open(url, 'mywin','left=20,top=20,width=500,height=500,toolbar=1,resizable=0');
      }

      if (platform === 'email') {
        url = 'mailto:?subject='+subject+'&body=' + pageUrl;
        url = encodeURI(url);

        window.open(url);
      }

      if (platform === 'clipboard') {
        navigator.clipboard.writeText(pageUrl);

        $(this).find('.tooltip').show();

        setTimeout(() => {
          $(this).find('.tooltip').fadeOut(1000);
        }, 1000);

        // navigator.clipboard.write(pageUrl).then(function() {
        //   $(this).find('.tooltip').show();

        //   setTimeout(() => {
        //     $(this).find('.tooltip').fadeOut(1000);
        //   }, 1000);
        // }, function() {
        //   console.error("Unable to write to clipboard. :-(");
        // });
      }
    });
  }
});
